import React from 'react';

const CalendarIcon = ({ color = 'currentColor' }) => (
  <svg aria-hidden={true} width="18" height="18" fill="none" viewBox="0 0 24 22">
    <path stroke={color} strokeWidth={2} strokeLinecap="round" d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z" />
  </svg>

);

export default CalendarIcon;